import React, { useState, useMemo, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEraser, faPlus } from '@fortawesome/free-solid-svg-icons'

import MapTableInterface from '../forms/MapTableInterface.js';
import DatePicker from "react-datepicker";
import InputWrapper from '../forms/InputWrapper.js';
import WeightInput from '../forms/ManagedWeightInput.js';
import { callback } from '../../helpers.js';

import api from '../../api/index.js';

export default (props) => {

	const [recordId, setRecordId] = useState(props.recordId || false);
	const [date, setDate] = useState(props.date);
	const [receipt, setReceipt] = useState(props.invoice || '');
	const [processor, setProcessor] = useState(props.processor);
	const [weight, setWeight] = useState(props.weight || 0);
	const [saveDisabled, setSaveDisabled] = useState(false);

	//const rowbase = {'field': false, weight: 0};
	//const [rows, setRows] = useState(props.rows);
/*
	// ... Some thing to add fields to it
	useMemo(()=>{
		console.log("Resetting state", props);
		setRecordId(props.recordId || false);
		setDate(props.date || false);
		setInvoice(props.invoice || '');
		setProcessor(props.processor || false);
		setGrade(props.grade || false);
		if (props.rows)
			setRows(props.rows)
		else
			setRows([Object.assign(rowbase)]);
	}, [props.recordId]);
	
	
	
	
	const rowChange = (i, e) => {
		console.log(i, e);
		let r = JSON.parse(JSON.stringify(rows))
		switch(e.target.name) {
			case 'field':
				r[i]['field'] = e.target.value;
				break;
			case 'weight':
				r[i]['weight'] = e.target.value;
				break;
		}
		setRows(r);
	}
	
	const more = (e) => {
		e.preventDefault();
		setRows(rows.concat(rowbase));
	}
	*/
	

	const save = async (e) => {
		setSaveDisabled('disabled');
		e.preventDefault();
		// Package the info for saving
		let payload = {
			date: date.api(),
			receiptNumber: receipt,
			processor: processor,
			weight: weight,
		}
		
		// Also grab props.records and add it... if it's not specified leave it out
		if (props.records) {
			payload['harvestRecords'] = props.records;
		}

		console.log("Saving", payload);
		
		try {
			let response = false;
			console.log(recordId);
			if (recordId == false || typeof recordId === 'undefined') {
				//payload['fields'] = JSON.stringify(payload['fields']);
				response = await api.post('harvests/receipts', payload);
				callback(props.onAdded, [response]);
			} else {
				response = await api.put('harvests/receipts/' + recordId, payload);
				callback(props.onSaved, [response]);
			}
		} catch(e) {
			api.handleExceptions(e);
			setSaveDisabled(false);
		};
	}

	return <div className="processor-receipt-form">
		<InputWrapper label="Date: "  info="The date of this processor receipt.">
			<DatePicker
				id="date"
				selected={date}
				onChange={(e)=>setDate(e)}
			/>
			<button onClick={(e)=>setDate(null)} className="block plus" title="Clear the date"><FontAwesomeIcon icon={faEraser} className="eraserIcon" /></button>
		</InputWrapper>
		<InputWrapper label="Receipt Number: "  info="The receipt number associated with this processor receipt." description={!props.hasOwnProperty('recordId') ? '' : 'Please note that if you change the processor, all the associated harvest records will be unlinked from this receipt.'}>
			<input type="text" className="receipt" name="receipt" value={receipt} onChange={(e)=>setReceipt(e.target.value)} />
		</InputWrapper>
		<InputWrapper label="Processor: "  info="The processor associated with this receipt.">
		<MapTableInterface 
			maptable="processors" 
			value={processor} 
			name="processor" 
			onChange={(e)=>setProcessor(e.target.value.value)} 
		/>
		</InputWrapper>
		<InputWrapper label="Weight: "  info="The weight the processor recorded.">
			<WeightInput baseUnits="kg" name="weight" value={weight} onChange={(e)=>setWeight(e.target.value)} />
		</InputWrapper>
		<div className="children">
		{props.children}
		</div>
		<button disabled={saveDisabled} className="block" onClick={save}>Save</button>
	</div>;
}